module.exports = __webpack_public_path__ + "public/adminIcons/managePaymentGatewayIcon.svg?6ad0c760";